import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
import styled from '@emotion/styled';
import React, { useState, useEffect } from 'react';
import {
  useAppDispatch,
  updateLoggedInFormDataConsent
} from '../../../../redux';
import { useSimpleSignupState } from '../../hook';
import { FieldType } from '../model';
import { FieldWrapper } from '../styled';
import { messages } from '../../messages';

type MarketingConsentCheckBoxType = {
  readonly controlled?: boolean;
};

export function MarketingConsentCheckBox({
  controlled
}: MarketingConsentCheckBoxType) {
  const [isChecked, setIsChecked] = useState(false);
  const { intl } = useSimpleSignupState();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!controlled) {
      return;
    }

    dispatch(
      updateLoggedInFormDataConsent({
        marketingConsent: isChecked
      })
    );
  }, [isChecked]);

  return (
    <StyledFieldWrapper>
      {controlled && (
        <CheckboxField name="marketingConsent">
          {({ fieldProps }: FieldType) => (
            <Checkbox
              {...fieldProps}
              isChecked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
              label={intl.formatMessage(messages.marketingConsent)}
            />
          )}
        </CheckboxField>
      )}
      {!controlled && (
        <CheckboxField name="marketingConsent">
          {({ fieldProps }: FieldType) => (
            <Checkbox
              {...fieldProps}
              label={intl.formatMessage(messages.marketingConsent)}
            />
          )}
        </CheckboxField>
      )}
    </StyledFieldWrapper>
  );
}
const StyledFieldWrapper = styled(FieldWrapper)`
  margin: 24px 0 0 0;

  label span {
    display: block !important;
    border: none !important;
    padding: 0 !important;
    border-radius: 3px;
    margin: 0;
    line-height: 20px;
    font-size: 100%;
    vertical-align: baseline;
    font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
      Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
    font-style: normal;
    font-size: 13px;
    letter-spacing: 0.3px;
  }
`;
